import { _ as _sfc_main } from "./VaBadge.vue_vue_type_script_lang-b362a173.mjs";
import { openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, renderSlot, createTextVNode, toDisplayString } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaBadge_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-badge__text" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["va-badge", _ctx.badgeClass]),
    role: "alert"
  }, [
    createElementVNode("span", {
      class: "va-badge__text-wrapper",
      style: normalizeStyle(_ctx.stylesComputed)
    }, [
      createElementVNode("span", _hoisted_1, [
        renderSlot(_ctx.$slots, "text", {}, () => [
          createTextVNode(toDisplayString(_ctx.text), 1)
        ])
      ])
    ], 4),
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
const _VaBadge = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaBadge as _
};

import '../../../VaBadge.css';
//# sourceMappingURL=VaBadge-393a8710.mjs.map
